<form [formGroup]="formGroup()" class="row gap-4">
  <div class="row gap-4">
    <!-- VITABENE_ID -->
    <div class="col-sm-12">
      <app-form-input
        [id]="'vitabeneId'"
        [label]="'EMPLOYEES.VITABENE_ID' | translate"
        [controlName]="'vitabeneId'"
        [formGroup]="formGroup()"
        [isRequired]="true"
        [type]="'number'"
      />
    </div>
    <!-- FIRST_NAME -->
    <div class="col-sm-12">
      <app-form-input
        [id]="'firstName'"
        [label]="'EMPLOYEES.FIRST_NAME' | translate"
        [controlName]="'firstName'"
        [formGroup]="formGroup()"
        [isRequired]="true"
      />
    </div>
    <!-- LAST_NAME -->
    <div class="col-sm-12">
      <app-form-input
        [id]="'lastName'"
        [label]="'EMPLOYEES.LAST_NAME' | translate"
        [controlName]="'lastName'"
        [formGroup]="formGroup()"
        [isRequired]="true"
      />
    </div>
    <!-- ABBREVIATION -->
    <div class="col-sm-12">
      <app-form-input
        [id]="'abbreviation'"
        [label]="'EMPLOYEES.ABBREVIATION' | translate"
        [controlName]="'abbreviation'"
        [formGroup]="formGroup()"

      />
    </div>
    <!-- MEDICINE_PERSONAL -->
    <div class="col-sm-12">
      <app-checkbox-input [label]="'EMPLOYEES.MEDICINE_PERSONAL' | translate"
                          [id]="'isNurse'"
                          [controlName]="'isNurse'"
                          [formGroup]="formGroup()"
        />
    </div>
  </div>
</form>
